import React from 'react';
import DOMPurify from 'dompurify';

export const sanitizeTranslation = (text, component = 'div', options = {}) => {
  const sanitizedText = () => ({ __html: DOMPurify.sanitize(text, { ADD_ATTR: ['target'] }) });
  const Tag = component;
  return <Tag dangerouslySetInnerHTML={ sanitizedText() } { ...options } />;
};